import React from "react";
import { ConfirmModal } from "../ui";

/**
 * The question `useMeetingLeaveGuard` asks when a host leaves a live class from
 * inside the app. Closing the tab gets the browser's own prompt instead, and
 * that one cannot be given words.
 */
const MeetingLeaveConfirm = ({ guard, noun = "class" }) => (
  <ConfirmModal
    show={guard.asking}
    onHide={guard.stay}
    onConfirm={guard.leave}
    title={`Leave this ${noun}?`}
    message={`The ${noun} keeps running for everyone else, but recording stops until you come back. To finish it, use End in the meeting.`}
    confirmText={`Leave ${noun}`}
    cancelText={`Stay in ${noun}`}
    variant="warning"
  />
);

export default MeetingLeaveConfirm;
